import type { DoctorAlternativeSuggestion } from "./DoctorAlternativeOfferModal";

// Only the 4 fields buildSuggestionProps actually reads. Kept as a `Pick` (rather than the
// full `DoctorAlternativeSuggestion`) because `MyAccountOrderDetails.tsx` declares its own
// narrower local type of the same shape for `OrderDetailsContext` — a `Pick` here stays
// structurally compatible with both call sites without widening either type.
type SuggestionForTracking = Pick<
  DoctorAlternativeSuggestion,
  "originalProductTitle" | "originalProductPrice" | "suggestedProductTitle" | "suggestedProductPrice"
>;

export const DOCTOR_ALTERNATIVE_EVENTS = {
  SHOW: "My account show doctor alternative",
  DECISION: "Decision on doctor alternative product",
} as const;

export const buildOrderBundleProps = (bundle: {
  hashID?: string;
  groupHashID?: string;
  status?: string;
  category?: string;
  price?: number | string;
}) => {
  const props: Record<string, string | number> = {};
  if (bundle.hashID !== undefined) props["Order ID"] = bundle.hashID;
  if (bundle.groupHashID !== undefined) props["Order Group ID"] = bundle.groupHashID;
  if (bundle.status !== undefined) props["Order Status"] = bundle.status;
  if (bundle.category !== undefined) props["Category"] = bundle.category;
  if (bundle.price !== undefined) props["Order Price"] = bundle.price;
  return props;
};

export const buildSuggestionProps = (doctorAlternativeSuggestions?: SuggestionForTracking[]) => {
  const suggestion = doctorAlternativeSuggestions?.[0];
  if (!suggestion) return {};
  return {
    "Old product": suggestion.originalProductTitle,
    "Old product price": suggestion.originalProductPrice,
    "Alternative product": suggestion.suggestedProductTitle,
    "Alternative product price": suggestion.suggestedProductPrice,
  };
};
